<template>
  <div :class="['page-bottom-summary', $attrs.class]">
    <div class="page-bottom-summary-content">
      <slot />
    </div>
  </div>
</template>

<style>
@reference '@/assets/main.css';

.page-bottom-summary {
  @apply sticky bottom-0 left-0 px-8 -mx-8 -mb-8 bg-gray-cool-50 z-10;
  width: calc(100% + var(--spacing) * 16);
  box-shadow: 0 -24px 16px 0 var(--color-gray-cool-50);
}

.page-bottom-summary-content {
  @apply py-6 border-t border-gray-200;
}
</style>
